
export default {
  props: {
    documentId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      document: {
      },
    };
  },
  computed: {
    fileUrl () {
      if (this.document.acf) {
        return this.document.acf.document_type === `internal`
          ? this.document.acf.document_file.url
          : this.document.acf.document_url;
      }
      return false;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getDocument();
    });
  },
  methods: {
    async getDocument () {
      const queryParams = {
        fields: `id,title,acf,slug`,
        posts: {
          post_type: `document`,
          posts_per_page: 1,
          p: this.documentId,
        },
      };

      const request = await this.$getPosts(`/posts`, queryParams);
      if (request !== null) {
        this.document = request[0];
      }
    },
  },
};
